module.exports = __webpack_public_path__ + "static/media/reshma.2d6da362.jpg";